module.exports = __webpack_public_path__ + "static/compIncorp-6a28f0d94a3beb40b6000e0ede09d2db.jpg";